var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-left !border-none !px-0 font-normal py-0",class:{
		'': _vm.risk.level === 'warn',
		'': _vm.risk.level === 'danger',
	},staticStyle:{"font-size":"0.8rem !important"},attrs:{"title":_vm.risk.description}},[_vm._v(" "+_vm._s(_vm.risk.name)+" "),(_vm.risk.level === 'danger')?_c('i',{staticClass:"bi-x-octagon-fill !text-sm mr-2 text-error float-right"}):_vm._e(),(_vm.risk.level === 'warn')?_c('i',{staticClass:"bi-exclamation-triangle-fill !text-sm mr-2 text-warn float-right"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }